import React from 'react'
import { withRouter } from 'react-router'
import { notify } from 'libs/common/notify'

import { TooltipMenu } from '@elo-kit/components/elo-ui/tooltip-menu/TooltipMenu'

import { withStores } from 'utils/helpers.utils'

const HmacKeysActions = (props) => {
  const {
    hmacKeysStore,
    match: {
      params: { id },
    },
  } = props

  const rotateHmacKey = async (id) => {
    const resp = await hmacKeysStore.rotateItem(id)

    if (resp?.success) {
      notify('success', 'Rotated successful')
      hmacKeysStore.fetchItem(id)
    }
  }

  const itemsWithAction = [
    {
      show: true,
      content: 'Rotate',
      action: () => rotateHmacKey(id),
      useConfirmation: true,
      titleText: 'Do you want to rotate this key?',
    },
  ]

  return (
    <TooltipMenu
      customIcon={() => (
        <i className='fas fa-cog elo-btn-icon--actions' id={`menu-tooltip-with-icons-hmac-keys-${id}`} />
      )}
      id={`hmac-keys-${id}`}
      menuItems={itemsWithAction}
    />
  )
}

export default withRouter(withStores(['hmacKeysStore'], HmacKeysActions))
